import { render } from "./EmailCompositionModal.vue?vue&type=template&id=3582ceff&scoped=true"
import script from "./EmailCompositionModal.vue?vue&type=script&lang=js"
export * from "./EmailCompositionModal.vue?vue&type=script&lang=js"

import "./EmailCompositionModal.vue?vue&type=style&index=0&id=3582ceff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3582ceff"]])

export default __exports__